// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import Tools from './lib/tools'
let tools = Tools()

require('./assets/styles/index.less');

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App :tools="tools" />',
  components: { App },
  data() {
  	return {
  		tools
  	}
  }
})



// WEBPACK FOOTER //
// ./src/main.js